
import { Component, OnInit, OnDestroy, Input, HostListener, ElementRef } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserService } from '../../shared/services/user.service';
import { CommonModule } from '@angular/common';

declare var jQuery: any;
declare var $: any;

@Component({
    standalone: true,
    imports: [
        RouterModule,
        CommonModule
    ],
    selector: 'top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.css']
})

export class TopBarComponent implements OnInit, OnDestroy {
    @Input()
    newUrl!: boolean;
    pageUrl: string = '';

    status!: boolean;
    subscription!: Subscription;

    constructor(private router: Router, public userService: UserService, private elRef: ElementRef) {

        router.events.subscribe((url: any) => {
            this.pageUrl = url.url;
        });
    }

    @HostListener('window:scroll', ['$event'])
    onWindowScroll(event) {
        const navbarFixedTop = this.elRef.nativeElement.querySelector('.fixed-top');

        if (navbarFixedTop) {
            if (window.pageYOffset > 50) {
                navbarFixedTop.classList.add('top-nav-collapse');
            } else {
                navbarFixedTop.classList.remove('top-nav-collapse');
            }
        }
    }
    ngOnInit(): void {
        this.subscription = this.userService.authNavStatus$.subscribe(status => this.status = status);
    }

    onclickToggle() {
        const navbarCollapse = this.elRef.nativeElement.querySelector('.navbar-collapse');
        const isCollapsed = navbarCollapse.classList.contains('show-toogle');
        
        if (isCollapsed) {
            navbarCollapse.classList.remove('show-toogle');
        } else {
            navbarCollapse.classList.add('show-toogle');
        }
    }
    logout() {
        //this.userService.logout();
    }

    ngOnDestroy() {
        // prevent memory leak when component is destroyed
        this.subscription.unsubscribe();
    }

    onWebClick() {
        let isMobile = /iPad|iPhone|iPod|Android/i.test(window.navigator.userAgent)

        if (isMobile) {
            window.location.href = 'https://8m40.app.link/tDWvQD7JqP';

            return;
        }

        this.router.navigate(['/ads']);
        //window.location.href = 'https://nesiyatovasite.azurewebsites.net/web/home/cemetery';
    }

    onClickLi() {
        const navbarCollapse = this.elRef.nativeElement.querySelector('.navbar-collapse');
        if (!this.newUrl) {
            console.log(this.newUrl,"new Url")
            navbarCollapse.classList.add('show-toogle');
        }else {
            navbarCollapse.classList.remove('show-toogle');
        }

    }

    onSearchClick() {
        console.log('serach');

        var modal = (<HTMLInputElement>document.getElementById('myModal'))
        modal.style.display = "block";
    }

    checkUrl() {
        //console.log(this.pageUrl);
        if (this.pageUrl == '/') {
            return true;
        }
        else {
            return false;
        }
    }

}